import type { StringDict } from "@/i18n/ui";

const dict: StringDict = {
  "Food / Candy": "Lebensmittel / Süßwaren",
  "Up to 1,160 sales per day over the previous month.": "Bis zu 1.160 Verkäufe pro Tag im vergangenen Monat.",
  "Up to 2,892 sales per day.": "Bis zu 2.892 Verkäufe pro Tag.",
  "Peak sales growth up to 149.31% in one day.": "Spitzenwachstum der Verkäufe von bis zu 149,31 % an einem Tag.",
  "For an invited publisher, blogger, or content creator.": "Für einen eingeladenen Publisher, Blogger oder Content-Creator.",
  "For an invited marketplace seller.": "Für einen eingeladenen Marketplace-Verkäufer.",
  "Of the confirmed advertising spend of an invited marketplace seller.": "Der bestätigten Werbeausgaben eines eingeladenen Marketplace-Verkäufers.",
  "Of the earned commission of an invited publisher, blogger, or content creator.": "Der verdienten Provision eines eingeladenen Publishers, Bloggers oder Content-Creators.",
  "Can I effectively promote one product with a €130 budget?": "Kann ich ein Produkt mit einem Budget von 130 € effektiv bewerben?",
  "For most sellers, this budget is too limited for a meaningful test. A small budget reduces reach, limits the number of traffic sources, and does not provide enough data to evaluate performance. We recommend starting with a larger test budget to compare several products, formats, and sources.": "Für die meisten Verkäufer ist dieses Budget für einen aussagekräftigen Test zu gering. Ein kleines Budget verringert die Reichweite, begrenzt die Anzahl der Traffic-Quellen und liefert nicht genügend Daten zur Leistungsbewertung. Wir empfehlen, mit einem größeren Testbudget zu starten, um mehrere Produkte, Formate und Quellen zu vergleichen.",
  "How many bloggers and publishers do you have?": "Wie viele Blogger und Publisher haben Sie?",
  "More than 16,000 bloggers, publishers, and content creators are connected to the Catuik platform.": "Mehr als 16.000 Blogger, Publisher und Content-Creator sind mit der Catuik-Plattform verbunden.",
  "You need a Catuik seller account, campaign settings, product data, and the required marketplace integration or product feed. The exact requirements depend on the marketplace and campaign setup.": "Sie benötigen ein Catuik-Verkäuferkonto, Kampagneneinstellungen, Produktdaten sowie die erforderliche Marketplace-Integration oder den Produkt-Feed. Die genauen Anforderungen hängen vom Marketplace und dem Kampagnen-Setup ab.",
  "Creator and Affiliate Campaigns for Growing Brands | Catuik": "Creator- und Affiliate-Kampagnen für wachsende Marken | Catuik",
  "SME Brand": "KMU-Marke",
  "Start your campaign": "Starten Sie Ihre Kampagne",
  "A simple way to start growing your brand": "Ein einfacher Weg, um das Wachstum Ihrer Marke zu starten",
  "Share a few details and our team will get your first campaign moving.": "Teilen Sie uns ein paar Details mit, und unser Team bringt Ihre erste Kampagne ins Rollen.",
  "Scope tailored to your growth stage": "Auf Ihre Wachstumsphase zugeschnittener Umfang",
  "Relevant creators and affiliate partners": "Relevante Creator und Affiliate-Partner",
  "We find relevant creators and affiliate partners, coordinate the campaign, and handle\n              day-to-day operations with a scope tailored to your goals, resources, and stage of\n              growth.": "Wir finden relevante Creator und Affiliate-Partner, koordinieren die Kampagne und übernehmen\n              das Tagesgeschäft mit einem Umfang, der auf Ihre Ziele, Ressourcen und Ihre\n              Wachstumsphase zugeschnitten ist.",
  "Introduce the product, communicate its value, and create initial audience interest.": "Das Produkt vorstellen, seinen Nutzen vermitteln und erstes Interesse bei der Zielgruppe wecken.",
  "Reach a new audience": "Eine neue Zielgruppe erreichen",
  "Connect with creators and partners already trusted by the customer segment you want to reach.": "Vernetzen Sie sich mit Creatorn und Partnern, denen das gewünschte Kundensegment bereits vertraut.",
  "Build trust and demand": "Vertrauen und Nachfrage aufbauen",
  "Use reviews, demonstrations, comparisons, and expert content to support purchase consideration.": "Nutzen Sie Bewertungen, Demonstrationen, Vergleiche und Experteninhalte, um die Kaufentscheidung zu unterstützen.",
  "Support sales growth": "Umsatzwachstum unterstützen",
  "Start with a clear business and marketing objective. The partner mix, content formats,\n            and campaign scope are built around it.": "Beginnen Sie mit einem klaren geschäftlichen und Marketingziel. Der Partnermix, die\n            Content-Formate und der Kampagnenumfang werden darauf abgestimmt.",
  "Audience fit": "Zielgruppen-Fit",
  "Category relevance": "Kategorierelevanz",
  "Content quality": "Content-Qualität",
  "Market and language": "Markt und Sprache",
  "Campaign readiness": "Kampagnenbereitschaft",
  "Lifestyle creator": "Lifestyle-Creator",
  "Priority match": "Priorisierte Übereinstimmung",
  "Category expert creator": "Kategorie-Experten-Creator",
  "Strong fit": "Starke Übereinstimmung",
  "Cashback and loyalty platform": "Cashback- und Treueplattform",
  "Relevant": "Relevant",
  "Potential match": "Mögliche Übereinstimmung",
  "Coupon and deals partner": "Coupon- und Deals-Partner",
  "We build a focused shortlist around your product, audience, category, market, content\n              requirements, commercial model, and campaign goal.": "Wir erstellen eine fokussierte Shortlist auf Basis Ihres Produkts, Ihrer Zielgruppe,\n              Kategorie, Ihres Marktes, der Content-Anforderungen, des Vergütungsmodells und\n              Kampagnenziels.",
  "h-3.5 w-3.5 shrink-0": "h-3.5 w-3.5 shrink-0",
  "Build awareness and trust": "Bekanntheit und Vertrauen aufbauen",
  "Best for: product launches, brand awareness, and reaching new audiences.": "Am besten geeignet für: Produkteinführungen, Markenbekanntheit und die Ansprache neuer Zielgruppen.",
  "Content and editorial partners": "Content- und Redaktionspartner",
  "Help customers understand the product": "Kunden helfen, das Produkt zu verstehen",
  "Best for: complex products, considered purchases, and category education.": "Am besten geeignet für: komplexe Produkte, überlegte Kaufentscheidungen und Kategorieaufklärung.",
  "Affiliate and loyalty partners": "Affiliate- und Treuepartner",
  "Turn interest into measurable action": "Interesse in messbare Handlungen umwandeln",
  "Best for: demand capture, acquisition testing, and sales support.": "Am besten geeignet für: Nachfragegewinnung, Akquisitionstests und Vertriebsunterstützung.",
  "Coupon and cashback partners": "Coupon- und Cashback-Partner",
  "Give customers an additional reason to buy": "Kunden einen zusätzlichen Kaufanreiz geben",
  "Best for: promotional campaigns, value-driven audiences, and repeat engagement.": "Am besten geeignet für: Aktionskampagnen, wertorientierte Zielgruppen und wiederkehrendes Engagement.",
  "A growing brand does not need the largest possible contact list. It needs a focused mix\n            of partners that can contribute at different stages of the customer journey.": "Eine wachsende Marke braucht keine möglichst große Kontaktliste. Sie braucht einen\n            fokussierten Mix an Partnern, die in verschiedenen Phasen der Customer Journey einen Beitrag leisten.",
  "Agree on the product, objective, audience, campaign scope, timing, and available resources.": "Einigung auf Produkt, Ziel, Zielgruppe, Kampagnenumfang, Zeitplan und verfügbare Ressourcen.",
  "Build the partner shortlist, contact selected partners, and coordinate cooperation terms.": "Erstellung der Partner-Shortlist, Kontaktaufnahme mit ausgewählten Partnern und Abstimmung der Kooperationsbedingungen.",
  "Prepare and launch": "Vorbereiten und starten",
  "Review and decide": "Prüfen und entscheiden",
  "Organize available results and define what should be continued, adjusted, or tested next.": "Verfügbare Ergebnisse strukturieren und festlegen, was fortgeführt, angepasst oder als Nächstes getestet werden soll.",
  "One point of contact": "Ein zentraler Ansprechpartner",
  "Keep campaign communication centralized while we handle partner follow-ups, questions, and ongoing coordination.": "Die Kampagnenkommunikation bleibt zentralisiert, während wir Partner-Follow-ups, Fragen und die laufende Koordination übernehmen.",
  "Approvals kept moving": "Freigaben laufen reibungslos",
  "We collect materials, organize feedback, and coordinate revisions so content moves through approval without unnecessary delays.": "Wir sammeln Materialien, organisieren Feedback und koordinieren Überarbeitungen, damit Inhalte ohne unnötige Verzögerungen den Freigabeprozess durchlaufen.",
  "Deadlines kept on track": "Termine werden eingehalten",
  "We monitor placement dates, required inputs, dependencies, and upcoming actions across the campaign.": "Wir überwachen Platzierungstermine, benötigte Inputs, Abhängigkeiten und anstehende Aktionen über die gesamte Kampagne hinweg.",
  "Clear campaign visibility": "Klare Kampagnenübersicht",
  "Receive structured status updates, available reporting, and practical recommendations without managing separate chats, spreadsheets, and reminders.": "Erhalten Sie strukturierte Statusupdates, verfügbare Reportings und praxisnahe Empfehlungen, ohne separate Chats, Tabellen und Erinnerungen verwalten zu müssen.",
  "Creator A": "Creator A",
  "Done": "Erledigt",
  "In review": "In Prüfung",
  "Scheduled": "Geplant",
  "Approved": "Genehmigt",
  "You stay involved in key decisions while we coordinate the day-to-day work across\n            partners, materials, approvals, deadlines, and campaign updates.": "Sie bleiben in wichtige Entscheidungen eingebunden, während wir das Tagesgeschäft über\n            Partner, Materialien, Freigaben, Fristen und Kampagnenupdates hinweg koordinieren.",
  "Partner": "Partner",
  "One coordinated workflow instead of multiple partners, conversations, deadlines, and\n                status requests.": "Ein koordinierter Workflow statt mehrerer Partner, Gespräche, Fristen und\n                Statusanfragen.",
  "Start with a focused campaign tailored to your product, audience, and resources, then\n            expand based on what you learn.": "Starten Sie mit einer fokussierten Kampagne, die auf Ihr Produkt, Ihre Zielgruppe und\n            Ressourcen zugeschnitten ist, und erweitern Sie diese anhand der gewonnenen Erkenntnisse.",
  "FOR BRAND & MARKETING AGENCIES": "FÜR MARKEN- & MARKETINGAGENTUREN",
  "url(#agglow)": "url(#agglow)",
  "url(#agglow2)": "url(#agglow2)",
  "url(#agsoft)": "url(#agsoft)",
  "url(#agtrend)": "url(#agtrend)",
  "currentColor": "currentColor",
  "translate(84 12)": "translate(84 12)",
  "translate(150 30)": "translate(150 30)",
  "translate(8 34)": "translate(8 34)",
  "translate(8 12)": "translate(8 12)",
  "Products": "Produkte",
  "Promos": "Aktionen",
  "Links": "Links",
  "Statuses": "Status",
  "url(#ae-glow)": "url(#ae-glow)",
  "url(#ae-core)": "url(#ae-core)",
  "Single integration": "Einmalige Integration",
  "Auto updates": "Automatische Updates",
  "Reliable sync": "Zuverlässige Synchronisierung",
  "Less manual work": "Weniger manueller Aufwand",
  "translate(503 431) scale(0.62)": "translate(503 431) scale(0.62)",
  "Postback": "Postback",
  "translate(126 22)": "translate(126 22)",
  "translate(126 16)": "translate(126 16)",
  "translate(8 10)": "translate(8 10)",
  "translate(132 20)": "translate(132 20)",
  "translate(140 18)": "translate(140 18)",
  "translate(8 26)": "translate(8 26)",
  "translate(110 8)": "translate(110 8)",
  "translate(110 52)": "translate(110 52)",
  "ed-arrow h-4 w-4": "ed-arrow h-4 w-4",
  "translate(214 158)": "translate(214 158)",
  "translate(316 32)": "translate(316 32)",
  "translate(52 128)": "translate(52 128)",
  "translate(160 118)": "translate(160 118)",
  "translate(240 196)": "translate(240 196)",
  "translate(16 18)": "translate(16 18)",
  "translate(52 196)": "translate(52 196)",
  "translate(30 26)": "translate(30 26)",
  "translate(216 172)": "translate(216 172)",
  "translate(18 20)": "translate(18 20)",
  "translate(16 132)": "translate(16 132)",
  "translate(252 10)": "translate(252 10)",
  "translate(30 262)": "translate(30 262)",
  "url(#bhsoft)": "url(#bhsoft)",
  "url(#bhgrow)": "url(#bhgrow)",
  "./LocaleLink": "./LocaleLink",
  "motion-reduce:transform-none motion-reduce:transition-none": "motion-reduce:transform-none motion-reduce:transition-none",
  "./Section": "./Section",
  "./CtaButton": "./CtaButton",
  "./CaseStudyCard": "./CaseStudyCard",
  "./Reveal": "./Reveal",
  "./CaseStudyHeroIllustration": "./CaseStudyHeroIllustration",
  "./LeadCaptureModal": "./LeadCaptureModal",
  "Lamobile": "Lamobile",
  "Escape": "Escape",
  "max-w-[840px]": "max-w-[840px]",
  "fixed placements (fixed fee + CPA)": "feste Platzierungen (Festpreis + CPA)",
  "basic CPA model": "einfaches CPA-Modell",
  "promo code tracking": "Promo-Code-Tracking",
  "personal promo code": "persönlicher Promo-Code",
  "dash cams": "Dashcams",
  "partner network continues to expand": "Das Partnernetzwerk wächst weiter",
  "Overview": "Übersicht",
  "(prefers-reduced-motion: reduce)": "(prefers-reduced-motion: reduce)",
  "divide-y divide-[var(--brand-black)]/10": "divide-y divide-[var(--brand-black)]/10",
  "mx-auto max-w-[1140px]": "mx-auto max-w-[1140px]",
  "Case Study Hero CTA": "Case-Study-Hero-CTA",
  "divide-y divide-border": "divide-y divide-border",
  "case report": "Fallstudienbericht",
  "cs-in cs-drift": "cs-in cs-drift",
  "transform 500ms cubic-bezier(0.22, 1, 0.36, 1)": "transform 500ms cubic-bezier(0.22, 1, 0.36, 1)",
  "translate(-34 -26) rotate(-9 240 190)": "translate(-34 -26) rotate(-9 240 190)",
  "translate(-18 -14) rotate(-5 240 190)": "translate(-18 -14) rotate(-5 240 190)",
  "translate(20 -6) rotate(4 240 190)": "translate(20 -6) rotate(4 240 190)",
  "translate(98 52)": "translate(98 52)",
  "translate(28 104)": "translate(28 104)",
  "translate(340 206)": "translate(340 206)",
  "translate(20 40)": "translate(20 40)",
  "translate(20 128)": "translate(20 128)",
  "translate(78 128)": "translate(78 128)",
  "translate(224 132)": "translate(224 132)",
  "translate(34 66)": "translate(34 66)",
  "translate(140 54)": "translate(140 54)",
  "translate(262 140)": "translate(262 140)",
  "translate(24 96)": "translate(24 96)",
  "translate(252 146)": "translate(252 146)",
  "translate(228 130)": "translate(228 130)",
  "translate(22 52)": "translate(22 52)",
  "translate(22 146)": "translate(22 146)",
  "translate(22 190)": "translate(22 190)",
  "translate(222 132)": "translate(222 132)",
  "firstName": "firstName",
  "lastName": "lastName",
  "primaryMarket": "primaryMarket",
  "publisherType": "publisherType",
  "trafficSource": "trafficSource",
  "monthlyAudience": "monthlyAudience",
  "audienceMarkets": "audienceMarkets",
  "./geo/countries": "./geo/countries",
  "0 1px 2px oklch(0.2 0.01 260 / 0.05), 0 12px 28px -22px oklch(0.2 0.01 260 / 0.35)": "0 1px 2px oklch(0.2 0.01 260 / 0.05), 0 12px 28px -22px oklch(0.2 0.01 260 / 0.35)",
  "oklch(0.965 0.014 95)": "oklch(0.965 0.014 95)",
  "oklch(0.932 0.02 95)": "oklch(0.932 0.02 95)",
  "oklch(0.9 0.17 100)": "oklch(0.9 0.17 100)",
  "oklch(0.84 0.16 96)": "oklch(0.84 0.16 96)",
  "url(#cnt-sea)": "url(#cnt-sea)",
  "oklch(0.945 0.075 98)": "oklch(0.945 0.075 98)",
  "oklch(0.962 0.042 98)": "oklch(0.962 0.042 98)",
  "url(#cnt-hl)": "url(#cnt-hl)",
  "oklch(0.955 0.055 98)": "oklch(0.955 0.055 98)",
  "oklch(0.975 0.006 95)": "oklch(0.975 0.006 95)",
  "oklch(0.905 0.008 95)": "oklch(0.905 0.008 95)",
  "oklch(0.2 0.01 260 / 0.75)": "oklch(0.2 0.01 260 / 0.75)",
  "oklch(0.2 0.01 260 / 0.32)": "oklch(0.2 0.01 260 / 0.32)",
  "oklch(0.2 0.01 260 / 0.16)": "oklch(0.2 0.01 260 / 0.16)",
  "oklch(0.2 0.01 260 / 0.35)": "oklch(0.2 0.01 260 / 0.35)",
  "oklch(0.2 0.01 260 / 0.85)": "oklch(0.2 0.01 260 / 0.85)",
  "oklch(0.97 0.014 95)": "oklch(0.97 0.014 95)",
  "oklch(0.16 0.01 260)": "oklch(0.16 0.01 260)",
  "FOR CREATOR & PUBLISHER AGENCIES": "FÜR CREATOR- & PUBLISHER-AGENTUREN",
  "url(#crsoft)": "url(#crsoft)",
  "url(#crgrow)": "url(#crgrow)",
  "caeBar": "caeBar",
};

export default dict;
